<template>
  <div class="dongjian">
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search" @click="$router.push({ path: '/search' })"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a">首页</router-link>
        </li>
        <li
          v-for="(item, index) in navList"
          :key="item.id"
          @click="
            oneIndex = index
            getList(item.id)
          "
        >
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="a" :class="index == oneIndex ? 'sel' : ''">
            {{ item.name }}</router-link
          >
        </li>
      </ul>
    </header>
    <div class="sy_banner">
      <van-swipe class="sy_swipe" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <img :src="item.image" class="img" />
        </van-swipe-item>
      </van-swipe>
      <div class="dots">
        <div class="nei">
          <i :class="i == current ? 'sel' : ''" v-for="(item, i) in bannerList" :key="i"></i>
        </div>
      </div>
    </div>
    <main>
      <h5>{{ title }}</h5>
      <ul class="act_list">
        <li v-for="item in list" :key="item.id">
          <div to="" class="a" @click="levelThree(item.id, item.items_id)">
            <img :src="item.image" alt="" class="img" />
            <div class="title">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </li>
      </ul>
    </main>
    <div class="di_tishi">
      <strong>风险提示 ：</strong><br />
      市场有风险，投资须谨慎。本网站相关观点为当前观点，未来可能随着市场的变化而变化，亦不构成任何投资建议及基金投资收益的保证。
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 0,
      bannerList: [{ src: '../static/img/001.png' }],
      navList: [],
      id: '',
      oneIndex: '',
      list: [],
      title: '',
    }
  },
  created() {
    this.id = this.getQueryValue('id')
    this.oneIndex = this.getQueryValue('index')
    this.getNav()
    this.getList()
    this.getBanner()
    this.getTitle()
  },
  methods: {
    //轮播
    onChange(index) {
      this.current = index
    },
    async getBanner() {
      const res = await this.axios.get(`/item_banners/index?items_id=${this.id}`)
      if (res.code === 1) {
        this.bannerList = res.data
      }
    },
    async getNav() {
      const res = await this.axios.get('/index/tabs')
      if (res.code === 1) {
        this.navList = res.data
      }
    },
    async getList() {
      const res = await this.axios.get(`/cards/list?items_id=${this.id}`)
      if (res.code === 1) {
        this.list = res.data
      }
    },
    async getTitle() {
      const res = await this.axios.get(`/items/info?items_id=${this.id}`)
      if (res.code === 1) {
        console.log(res)
        this.title = res.data.name
      }
    },
    levelThree(cards_id, id) {
      this.$router.push({
        path: `/licai2?id=${id}&cards_id=${cards_id}&index=${this.oneIndex}`,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.dongjian {
  .header {
    position: sticky;
    top: 0;
    z-index: 1000;
    margin-bottom: -0.6rem;
    .top {
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0 0 0.3rem;
      background: #fff;
      .logo {
        display: flex;
        height: 1rem;
        align-items: center;
        .img {
          max-height: 0.46rem;
          margin-right: 0.4rem;
        }
      }
      .search {
        width: 1rem;
        height: 1rem;
        background: url(../assets/img/search.png) no-repeat center center;
        background-size: 0.41rem;
      }
    }
    .nav {
      width: 100%;
      background: url(../assets/img/bg_01.png) no-repeat left top;
      background-size: 100% 100%;
      height: 0.96rem;
      line-height: 0.8rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      li {
        padding: 0;
        margin: 0;
        width: 50%;
        text-align: center;
        height: 0.96rem;
        display: flex;
      }
      .a {
        width: 100%;
        color: #fff;
        font-size: 0.28rem;
        height: 0.8rem;
        display: inline-block;
        line-height: 0.8rem;
        position: relative;
        &.sel {
          font-weight: bold;
          background: url(../assets/img/bg_02.png) no-repeat center 85%;
          background-size: auto 0.02rem;
        }
      }
    }
  }
  .sy_banner {
    position: relative;
    .sy_swipe {
      .img {
        display: block;
        width: 100%;
      }
    }
    .dots {
      width: 100%;
      position: absolute;
      bottom: 0;
      z-index: 10;
      height: 0.4rem;
      background-size: 100% 100%;
      text-align: right;
      padding-right: 0.3rem;
      line-height: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row-reverse;
      .nei {
        display: flex;
      }
      i {
        width: 0.1rem;
        height: 0.1rem;
        background: #fff;
        border-radius: 5px;
        display: inline-block;
        margin-left: 8px;
        transition: 0.4s;
      }
      .sel {
        width: 0.9rem;
      }
    }
  }
  main {
    width: 90%;
    margin: auto;
    .act_list {
      li {
        margin-bottom: 0.2rem;
        width: 100%;
        overflow: hidden;
        border-radius: 6px;
        position: relative;
        box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
        .img {
          width: 100%;
          display: block;
        }
        .title {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 0 0.2rem;
          display: flex;
          align-items: center;
          flex-direction: row-reverse;
          color: #fff;
          line-height: 0.6rem;
          font-weight: bold;
          span {
            text-shadow: 0.03rem 0.03rem 0.07rem rgba(40, 39, 40, 0.34);
            font-size: 0.52rem;
          }
        }
      }
    }
  }
  h5 {
    font-size: 0.3rem;
  }
  .di_tishi {
    padding: 0.6rem 0.32rem;
    color: rgba(153, 153, 153, 0.59);
    line-height: 0.28rem;
    font-size: 0.18rem;
    font-weight: normal;
  }
}
</style>
